class Config {

  static _instance = new Config();

  static getInstance() {
    return Config._instance;
  }

  get(key, defaultValue = undefined) {
    return localStorage.getItem(key) || defaultValue;
  }

  set(key, value) {
    localStorage.setItem(key, value);
  }

  get numOfVariations() {
    if (!this.get("numOfVariations")) {
      const value = !this.isPC() ? 3 : 5;
      this.set("numOfVariations", value);
    }
    return parseInt(this.get("numOfVariations"));
  }

  set numOfVariations(num) {
    this.set("numOfVariations", parseInt(num));
  }

  get nodesPerMove() {
    if (!this.get("nodesPerMove")) {
      const value = !this.isPC() ? 2000 : 10000;
      this.set("nodesPerMove", value);
    }
    return parseInt(this.get("nodesPerMove"));
  }

  set nodesPerMove(nodes) {
    if (nodes < 10) {
      alert("Too small!");
      return;
    }
    this.set("nodesPerMove", parseInt(nodes));
  }

  get maxDbSize() {
    if (!this.get("maxDbSize")) {
      const value = !this.isPC() ? 100000 : 1000000;
      this.set("maxDbSize", value);
    }
    return parseInt(this.get("maxDbSize"));
  }

  set maxDbSize(size) {
    if (size < 1000) {
      alert("Too small!");
      return;
    }
    this.set("maxDbSize", parseInt(size));
  }

  get fontSize() {
    if (!this.get("fontSize")) {
      this.set("fontSize", 8);
    }
    return parseInt(this.get("fontSize"));
  }

  set fontSize(size) {
    this.set("fontSize", parseInt(size));
  }

  get hideLessVisits() {
    if (this.get("hideLessVisits") === undefined) {
      this.set("hideLessVisits", 1);
    }
    return parseInt(this.get("hideLessVisits"));
  }

  set hideLessVisits(hide) {
    this.set("hideLessVisits", parseInt(hide));
  }

  isPC() {
    if (navigator.userAgentData) {
      return !navigator.userAgentData.mobile;
    } else if (navigator.userAgent.indexOf("Android") !== -1) {
      return false;
    } else if (navigator.userAgent.indexOf("iPhone") !== -1) {
      return false;
    } else if (navigator.userAgent.indexOf("Windows") !== -1
      || (navigator.userAgent.indexOf("Macintosh") !== -1)
      || (navigator.userAgent.indexOf("CrOS") !== -1)
      || (navigator.userAgent.indexOf("x86_64") !== -1)) {
      return true;
    }
    return false;
  }
}

export default Config;